import { assign } from 'xstate';

import { type CustomizationDataResponse, type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Stores customization data for a product, associated restaurant and optional
 * line item details.
 */
export const storeCustomizationData: CustomizationMachineAction<CustomizationDataResponse> = assign(
  (_, params) => {
    return {
      product: params.product,
      productRestaurant: params.restaurant,
      productLineItem: params.lineItem,
    };
  },
);
